import EmployeesList from '../components/Employees/EmployeesList';

export default function EmployeesPage() {
  return (
    <div style={{ paddingTop: '20px' }}>
      <EmployeesList />
    </div>
  );
}